import dayjs from "dayjs";

export const dateToISO = (date: Date) => {
  return dayjs(date).format("YYYY-MM-DD");
};

export const getWeekStart = (date: Date) => {
  return dayjs(date).startOf("week").startOf("day").toDate();
};

export const getMonthStart = (date: Date) => {
  return dayjs(date).startOf("month").toDate();
};

export const isSameDate = (leftDate: Date, rightDate: Date) => {
  return dayjs(leftDate).isSame(dayjs(rightDate), "day");
};

export const isSameMonth = (leftDate: Date, rightDate: Date) => {
  return dayjs(leftDate).isSame(dayjs(rightDate), "month");
};

export const getWeekNumber = (date: Date) => {
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayOfWeek = utcDate.getUTCDay() || 7;
  utcDate.setUTCDate(utcDate.getUTCDate() + 4 - dayOfWeek);
  const yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));
  return Math.ceil((Number(utcDate) - Number(yearStart) + 86400000) / 604800000);
};

